import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const t = (iso) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

// Mirrors the on-screen grid: employees × Mon..Sun, plus weekly total hours.
export const exportSchedulePdf = ({ days, employees, shifts, totals, storeName, weekLabel }) => {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
  doc.setFont("helvetica", "bold").setFontSize(16).text(`Weekly Schedule — ${storeName}`, 40, 40);
  doc.setFont("helvetica", "normal").setFontSize(11).text(weekLabel, 40, 58);

  const head = [["Employee", ...days.map((d) => d.toLocaleDateString(undefined, { weekday: "short", month: "numeric", day: "numeric" })), "Total"]];
  const body = employees.map((emp) => [
    emp.name,
    ...days.map((d) => {
      const key = d.toISOString().slice(0, 10);
      return shifts.filter((s) => s.employee_id === emp.id && (s.start_at || "").slice(0, 10) === key)
        .map((s) => `${t(s.start_at)} – ${t(s.end_at)}`).join("\n") || "—";
    }),
    `${(totals[emp.id] || 0).toFixed(2)} h`,
  ]);
  const grand = Object.values(totals).reduce((a, b) => a + b, 0);

  autoTable(doc, {
    startY: 74, head, body,
    foot: [["Total", ...days.map(() => ""), `${grand.toFixed(2)} h`]],
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 6, valign: "middle", halign: "center" },
    headStyles: { fillColor: [53, 28, 21], textColor: 255 },
    footStyles: { fillColor: [255, 181, 0], textColor: 20, fontStyle: "bold" },
    columnStyles: { 0: { halign: "left", fontStyle: "bold", cellWidth: 110 }, 8: { fontStyle: "bold" } },
  });
  doc.setFontSize(8).setTextColor(120).text(`Printed ${new Date().toLocaleString()}`, 40, doc.internal.pageSize.getHeight() - 20);
  doc.save(`schedule-${days[0].toISOString().slice(0, 10)}.pdf`);
};
